import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function CustomerRegister() {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', cpf: '', zipCode: '', fullAddress: '', password: '', acceptedTerms: false,
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const f = (k) => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register({ ...form, role: 'customer' });
      nav('/cliente/home');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao cadastrar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen bg-white flex flex-col">
      <div className="bg-gradient-to-b from-[#1A1A2E] to-[#16213E] px-6 pt-14 pb-10 text-white">
        <button onClick={() => nav('/cliente/login')} className="text-2xl mb-6 block">←</button>
        <div className="text-5xl mb-3">🛒</div>
        <h1 className="text-2xl font-black">Criar Conta de Cliente</h1>
        <p className="text-gray-400 text-sm mt-1">Rápido e fácil</p>
      </div>

      <form onSubmit={handle} className="flex-1 px-6 py-8 space-y-4 overflow-y-auto">
        {[
          { k: 'name', label: 'Nome completo', type: 'text', ph: 'João Silva' },
          { k: 'email', label: 'Email', type: 'email', ph: 'seu@email.com' },
          { k: 'phone', label: 'Telefone / WhatsApp', type: 'tel', ph: '(11) 99999-9999' },
          { k: 'cpf', label: 'CPF', type: 'text', ph: '000.000.000-00' },
          { k: 'zipCode', label: 'CEP', type: 'text', ph: '00000-000' },
          { k: 'password', label: 'Senha', type: 'password', ph: '••••••••' },
        ].map(({ k, label, type, ph }) => (
          <div key={k}>
            <label className="block text-sm font-semibold text-gray-600 mb-1">{label}</label>
            <input
              type={type}
              required
              value={form[k]}
              onChange={f(k)}
              placeholder={ph}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary"
            />
          </div>
        ))}

        <div>
          <label className="block text-sm font-semibold text-gray-600 mb-1">Endereço completo</label>
          <textarea
            required
            rows={3}
            value={form.fullAddress}
            onChange={f('fullAddress')}
            placeholder="Rua, número, bairro, cidade, complemento"
            className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-primary resize-none"
          />
        </div>

        <label className="flex items-start gap-3 bg-gray-50 rounded-2xl p-4">
          <input
            type="checkbox"
            checked={form.acceptedTerms}
            onChange={e => setForm(p => ({ ...p, acceptedTerms: e.target.checked }))}
            className="mt-1"
          />
          <span className="text-xs text-gray-600">
            Declaro estar ciente de que a plataforma atua apenas como intermediadora do pedido. Qualquer ocorrência envolvendo o entregador será apurada e serão tomadas as devidas providências.
          </span>
        </label>

        <button
          type="submit"
          disabled={loading || !form.acceptedTerms}
          className="w-full py-4 bg-primary hover:bg-primary-dark disabled:opacity-60 rounded-2xl font-bold text-white text-lg mt-2 transition-all active:scale-95"
        >
          {loading ? 'Criando conta...' : 'Criar Conta'}
        </button>

        <p className="text-center text-sm text-gray-500">
          Já tem conta?{' '}
          <Link to="/cliente/login" className="text-primary font-bold">Entrar</Link>
        </p>
      </form>
    </div>
  );
}
